export const baseURL = process.env.REACT_APP_API_URL || "/api";

export const companiesURL = `${baseURL}/companies`;

export const tasksURL = `${baseURL}/tasks`;

export const usersURL = `${baseURL}/users`;

export const askURL = `${baseURL}/ask`;

export const launchPagesUrl = `${baseURL}/launchpages`;